import { useTranslation } from "react-i18next";
import type { NoteStatus } from "@/services/api/entities/note/types";

export const getNoteStatusText = (status: NoteStatus) => {
  const { t } = useTranslation();

  switch (status) {
    case "TO_DO":
      return {
        dueText: t("common.status.toDo"),
        color: "date-to-do",
      };
    case "IN_PROGRESS":
      return {
        dueText: t("common.status.inProgress"),
        color: "date-to-do",
      };
    case "DONE":
      return {
        dueText: t("common.status.done"),
        color: "date-done",
      };
    default:
      return {
        dueText: "",
        color: "",
      };
  }
};
